import { action, makeObservable, observable } from 'mobx';
import { singleton } from 'tsyringe';

import { GetExercisesByClassifierCollaboration } from '@/application/collaborations/get-exercises-by-classifier.collaboration';
import { QuizDto } from '@/application/interfaces/pegasus.gateway';
import { ClassifiersModel } from '@/presentation/models/classifiers.model';

@singleton()
export class ExercisesModel {
  @observable quizzes: QuizDto[] = [];
  @observable shouldShowExerciseTab = false;

  constructor(
    private readonly getExercisesCollaboration: GetExercisesByClassifierCollaboration,
    private readonly classifiersModel: ClassifiersModel,
  ) {
    makeObservable(this);
  }

  @action.bound
  async getExercisesByClassifier() {
    try {
      const classifierGuid = this.classifiersModel.selectedClassifier?.guid;

      if (!classifierGuid) return;

      const { data } = await this.getExercisesCollaboration.run(classifierGuid);
      if (data) {
        this.quizzes = data;
        this.shouldShowExerciseTab = true;
      }
    } catch (error) {
      console.error(error);
      this.shouldShowExerciseTab = false;
    }
  }
}
